import React, { useEffect, useRef } from "react"
import PropTypes from "prop-types"
import { Route, Redirect, useLocation } from "react-router-dom"
import { LOCAL_STORAGE_TAGS, URL_PATHS } from "constants/index"

const Authmiddleware = ({
  component: Component,
  layout: Layout,
  isAuthProtected,
  userHasAccess,
  configFetchInterval = 0,
  fetchConfigs = () => {},
  vendorId,
  ...rest
}) => {
  const location = useLocation()
  const lastFetchedAt = useRef(0)

  useEffect(() => {
    const now = Date.now()

    if (
      isAuthProtected &&
      userHasAccess &&
      (!configFetchInterval ||
        now - lastFetchedAt?.current > configFetchInterval) &&
      !!vendorId
    ) {
      fetchConfigs(vendorId)
      lastFetchedAt.current = now
    }
  }, [
    location,
    isAuthProtected,
    userHasAccess,
    fetchConfigs,
    configFetchInterval,
    vendorId,
  ])

  return (
    <Route
      {...rest}
      render={props => {
        if (
          isAuthProtected &&
          !localStorage.getItem(LOCAL_STORAGE_TAGS.AUTH_USER)
        ) {
          return (
            <Redirect
              to={{
                pathname: URL_PATHS.LOGIN,
                state: { from: props.location },
              }}
            />
          )
        }
        if (isAuthProtected && userHasAccess === false) {
          return (
            <Redirect
              to={{ pathname: "/pages-404", state: { from: props.location } }}
            />
          )
        }
        return (
          <Layout>
            <Component {...props} />
          </Layout>
        )
      }}
    />
  )
}

Authmiddleware.propTypes = {
  isAuthProtected: PropTypes.bool,
  component: PropTypes.any,
  location: PropTypes.object,
  layout: PropTypes.any,
  fetchConfigs: PropTypes.func,
  configFetchInterval: PropTypes.number,
}

export default Authmiddleware
